import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraRouterProps } from "../InfraRouterProps";
import { InfraEntities } from "../InfraEntities";

interface IncidentListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class IncidentListPage extends Component<IncidentListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.incident(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}